(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('captcha', ['$window', '$compile', function($window, $compile) {
            return {
                restrict: 'AE',                
                replace: true,
                scope: {},
                require: 'ngModel',
                link: function(scope, elem, attrs, ngModel) {

                    var id, grecaptcha;
                    var key = '6Lcm2L4UAAAAADs4N3CHUR3ru7iCby6aqd7Fo9Ik';

                    function iscaptchaReady() {
                        if(angular.isDefined($window.grecaptcha)) {
                            id = $window.grecaptcha.render(elem[0], {
                                'sitekey': key,
                                callback: verifyCallback,
                                "expired-callback": expiredCallback
                            });
                        }
                        else {
                            console.log("reCaptcha unavailable");
                            return setTimeout(iscaptchaReady, 250);                            
                        }
                    }

                    iscaptchaReady();    

                    ngModel.$validators.captcha = function(modelValue, ViewValue) {
                        // if the viewvalue is empty, there is no response yet,
                        // so we need to raise an error.
                        return !!ViewValue;
                    };                    

                    function verifyCallback(response) {
                        // console.log('g-recaptcha-response: ' + response);
                        ngModel.$setViewValue(response);
                        ngModel.$render();                        
                    }

                    function expiredCallback() {
                        grecaptcha.reset(id);
                        ngModel.$setViewValue('');
                        ngModel.$render();
                    }                    

                }
            };
        }]);
})(window, window.angular);